import type { TicketMessage } from "../ticketDetail/messages/messageListOperations";

const ADD_MESSAGE = `ticket/messages/ADD_MESSAGE` as const;
const FETCH_MESSAGES = `ticket/messages/FETCH_MESSAGES` as const;

interface AddMessageAction {
  type: typeof ADD_MESSAGE;
  payload: TicketMessage;
}

interface FetchMessagesAction {
  type: typeof FETCH_MESSAGES;
  payload: TicketMessage[];
}

type TicketMessagesAction = AddMessageAction | FetchMessagesAction;

export const ticketMessagesReducer = (
  state: TicketMessage[] = [],
  action: TicketMessagesAction | { type: string } = { type: "" },
): TicketMessage[] => {
  switch (action.type) {
    case ADD_MESSAGE:
      return [...state, (action as AddMessageAction).payload];

    case FETCH_MESSAGES:
      return (action as FetchMessagesAction).payload;

    default:
      return state;
  }
};

export const addMessage = (ticket: TicketMessage): AddMessageAction => ({
  type: ADD_MESSAGE,
  payload: ticket,
});
